import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import QMyStatsSubmenu from '@/components/navigation/Submenus/QMyStatsSubmenu.vue'
import QLeaderboardDataTableWrapper from '@/components/datatables/QLeaderboardDataTableWrapper.vue'
import QBusinessTimePeriodSelect from '@/components/utils/QBusinessTimePeriodSelect.vue'
import QDataTableHeader from '../../components/datatables/base/QDataTableHeader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Leaderboards',
  setup(__props) {

const datePeriod = ref({ label: 'Current Month', period: 'month' })

const time_period = computed(() => {
	const timePeriodMap = {
		week: 'weekly',
		month: 'monthly',
		year: 'yearly',
	}
	return timePeriodMap[datePeriod.value.period]
})

const headersConfig = [
	{ text: 'Rank', value: 'Rank', width: 70, mobileWidth: 0, align: 'center', class: 'rank-header' },
	{ text: 'Name', value: 'AgentName', width: 150, mobileWidth: 'max-content', class: 'header-class' },
	{ text: 'APV', value: 'APV', width: 150, mobileWidth: 0, align: 'right', type: 'currency' },
]

const resetInfo = 'APV is the split percentage of the resetting agent.'
const SMEInfo = 'APV of total reset application written.'

return { __sfc: true,datePeriod, time_period, headersConfig, resetInfo, SMEInfo, QMyStatsSubmenu, QLeaderboardDataTableWrapper, QBusinessTimePeriodSelect, QDataTableHeader }
}

})